<template>
  <div id="QA" class="page">
    <div v-html="contents"></div>
    <slot></slot>
    <!--最下部に<CENTER>[閉じる]</CENTER>ボタンを設置して、押すとデザイン画面に飛ぶ仕様にしたいです。-->
  </div>
</template>

<script>
  import axios from 'axios/dist/axios.min'
  export default {
    name: 'Faq',
    data() {
      return {
        contents: ''
      }
    },
    created () {
      axios.get('/pages/faq.json').then(response => {
        this.contents = response.data.pages[0].body;
      })
    },
  }
</script>


<style scoped>
  .page{
    padding: 10px 10px 60px 10px;
  }
</style>
